
<template>
    <div>
        <mars-view :class="['law-regulations-container', isSwan ? 'swan-container' : 'h5-container']"><mars-view><mars-view class="law-question-card-top" :style="{'height': entireHeight + 'px'}"></mars-view><mars-view :class="!scrollToBottom ? entireHeight === 44 ? 'law-question-card-bg-h5' : 'law-question-card-bg' : ''"></mars-view></mars-view><top-bar v-if="topBar.bgColor" key="hosted" :title-icon="titleIcon" :no-blank="true" :title="hostedContentFrom" :bg-color="topBar.bgColor" :text-color="topBar.color" :home-flag="hostedContentFrom === '律临'" :no-show-home="hostedContentFrom !== '律临'"></top-bar><tab-menu @tabClick="tabClick"></tab-menu><mars-view class="main-content-box"><law-content v-if="question.qid" :question-info="question" :answer="nowReplies" :cur-tab="curTab" :import-id="importId" :ads-eid="adsEid" :asp-feed-data="aspFeedData" :asp-change-data="aspChangeData" :law-ad-switch="lawAdSwitch" :font-size-setting="fontSizeSetting" @updateScrollToBottom="updateScrollToBottom"></law-content></mars-view><bottom-btn :onlione-consultants="onlioneConsultants" :law-clue-config-image-url="lawClueConfigImageUrl" :question="question" :font-size-setting="fontSizeSetting" @turnReserve="turnReserve"></bottom-btn></mars-view>
    </div>
</template>

<script>
/**
 * @file 法律法规
 */
/* globals getApp, Page, swan */
import log from '../../static/utils/ubcLog';
import TopBar from "../../components/common/topbar.vue";
import procData from './utils/proc-data.js';
import { dataPage } from './utils/commonData.js';
import lawContent from "./components/law-content.vue";
import bottomBtn from "./components/bottom-btn.vue";
import tabMenu from "./components/tab-menu.vue";
import Observer from '../../common/js/observer.js';
import { handleSearch } from '../../static/utils/search';
import { getFontSizeSetting } from '../../static/utils/index.js';
import { act } from '../../static/utils/navigate';
export default {
  components: {
    'top-bar': TopBar,
    'law-content': lawContent,
    'bottom-btn': bottomBtn,
    'tab-menu': tabMenu
  },
  computed: {
    hostedContentFrom() {
      let {
        ext_pack = {}
      } = this.question || {};
      const tpUnify = ext_pack.tp_unify || 0;
      const title = tpUnify !== 1 && ext_pack.title || '律临';
      return title;
    },
    titleIcon() {
      let {
        ext_pack = {}
      } = this.question || {};
      const tpUnify = ext_pack.tp_unify || 0;
      const title = tpUnify !== 1 && ext_pack.title || '律临';
      return title === '律临' ? 'https://lvlin-base.cdn.bcebos.com/law/pages/home/lvlin-logo-new.png' : ext_pack.icon;
    }
  },
  data() {
    return {
      entireHeight: 64,
      // 是否向底部滚动一定距离
      scrollToBottom: false,
      windowHeight: 0,
      isSwan: "h5" === 'swan',
      fontSizeSetting: 0,
      ...JSON.parse(JSON.stringify(dataPage))
    };
  },
  mounted() {
    this.mount();
    setTimeout(() => {
      this.$nextTick(() => {
        this.fontSizeSetting = getFontSizeSetting();
      });
    }, 200);
    this.$nextTick(() => {
      (function () {
        this.ready();
        this.$root.$emit("marsPageAfterMounted", this);
      }).call(this, this.$route.query);
    });
  },
  methods: {
    /**
     * 菜单切换
     * @param {object} tabItem 菜单信息
     */
    tabClick(tabItem) {
      let {
        type
      } = tabItem;
      if (this.curTab === type) {
        return;
      }
      this.curTab = type;
      this.scrollToBottom = false;
    },
    /**
     * 更新滚动状态
     * @param {boolean} flag
     */
    updateScrollToBottom(flag) {
      this.scrollToBottom = flag;
    },
    // 地步咨询按钮
    turnReserve() {
      let botJumpUrl = this.botJumpUrl;
      const from = `lvlinqg_bottom-chat_form_${'h5'}`;
      botJumpUrl += `&from=${encodeURIComponent(from)}`;
      act({
        target: botJumpUrl,
        type: 'webview'
      });
    },
    ...procData
  },
  created() {
    (function (query) {
      this.init(query);
    }).call(this, this.$route.query);
    (function (query) {
      query = query || {};
      let {
        cid
      } = query;
      log.addKey && log.addKey({
        fr: query.ref || query.fr || handleSearch(),
        page: 'regulation',
        qid: cid,
        ...query
      });
      log.send && log.send({
        serverId: 17017,
        area: 'all-show',
        action: 'show'
      });
      this.$root.$emit("marsPageAfterCreated", this);
    }).call(this, this.$route.query);
  },
  destroyed() {
    (function () {
      this.$root.$emit("marsPageAfterDestroyed", this);
    }).call(this, this.$route.query);
  },
  activated() {
    (function () {
      Observer.notify('onPageShow');
      setTimeout(() => {
        this.$nextTick(() => {
          this.fontSizeSetting = getFontSizeSetting();
        });
      }, 200);
      this.$root.$emit("marsPageAfterActivated", this);
    }).call(this, this.$route.query);
  },
  deactivated() {
    (function () {
      Observer.notify('onPageHide');
      this.$root.$emit("marsPageAfterDeactivated", this);
    }).call(this, this.$route.query);
  }
};
</script>

<style scoped>
.law-regulations-container {
  display: flex;
  flex-direction: column;
  z-index: 1;
  background: #fff;
  box-sizing: border-box;
  overflow: hidden;
}
.law-regulations-container.swan-container {
  position: relative;
  height: 100vh;
}
.law-regulations-container.h5-container {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.law-regulations-container .law-question-card-top {
  width: 100%;
  height: 0.66rem;
}
.law-regulations-container .law-question-card-bg-h5 {
  width: 100%;
  height: 2.05rem;
  background: url("https://lvlin-base.cdn.bcebos.com/law/common/page-bg.png") no-repeat;
  background-size: 100% 1.05rem;
  background-color: #fff;
  position: absolute;
  top: 0;
  left: 0;
}
.law-regulations-container .law-question-card-bg {
  width: 100%;
  height: 2.05rem;
  background: url("https://lvlin-base.cdn.bcebos.com/law/common/page-bg.png") no-repeat;
  background-size: 100% 1.62rem;
  background-color: #fff;
  position: absolute;
  top: 0;
  left: 0;
}
.law-regulations-container .main-content-box {
  position: relative;
  flex: 1;
  height: 100%;
  overflow: hidden;
}

</style>
